import script from "./AuthProvider.vue?vue&type=script&lang=ts"
export * from "./AuthProvider.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__